<template>
  <div class="fix-full-sceen scan-ui">
    <div
      v-bind:class="{'animated fadeIn horizontal-center toast-box':true,'fadeOut':fadeOut}"
      v-if="showErrorMsg"
    >{{qrErrorMsg}}</div>
    <div class="l-box">
      <div class="l-box-content">
        <img src="@/assets/img/app/UI_loading_chip.png" class="abs-center-box chip-png" />
        <img src="@/assets/img/app/UI_loading_LOGO_01.png" class="abs-center-box logo-png" />
        <div class="abs-center-box user-nick" v-show="nickname && scanUIType==2">
          <span class="s-nick">用户名称</span>
          <span class="s2">{{nickname}}</span>
        </div>
      </div>
      <div class="app-version">{{appVersion}}</div>
    </div>
    <div class="r-box">
      <div class="abs-center-box r-box-content" v-show="scanUIType==1">
        <div class="r-box-bg">
          <div id="scan-tips" class="scan-tips">
            <div class="tips">
              <img src="@/assets/img/app/UI_shouji_BG_02_01.png" class="tips-bg abs-center-box" />
              <div class="tips-content abs-center-box">请点击"扫描二维码"进入游戏，扫描游戏网页上的二维码，即可同步使用您的网页帐号进入游戏</div>
            </div>
            <img src="@/assets/img/app/UI_shouji_saomiao_02.png" class="scan-demo" />
          </div>
        </div>
        <a href="javascript:void(0)" class="scan-btn" @click="handleScan">扫描二维码进入游戏</a>
      </div>
      <div class="abs-center-box r-handlock-content" v-show="scanUIType==2">
        <span class="s-yellow" v-if="isSetPwd==1">请验证手势密码</span>
        <span class="s-yellow" v-else>请输入手势密码</span>
        <div class="handlock-box" ref="handBox">
          <div class="abs-center-box" ref="handLock"></div>
        </div>
        <a href="javascript:void(0)" class="forget-pwd" @click="forgetPwd"></a>
      </div>
    </div>
  </div>
</template>

<script>
import handLock from "@/utils/handLock";
import { mapState } from "vuex";
import qrTool from "@/logic/qrTool";
export default {
  name: "scanUI",
  components: {},
  data() {
    return {
      time: 2000,
      fadeOut: false,
      timer1: null,
      timer2: null,
      showErrorMsg: false
    };
  },
  computed: {
    ...mapState({
      nickname: state => state.user.nickname,
      userId: state => state.user.userId,
      scanUIType: state => state.user.scanUIType,
      isSetPwd: state => state.app.isSetPwd,
      qrErrorMsg: state => state.user.qrErrorMsg,
      appVersion: state => state.app.appVersion
    })
  },
  watch: {
    qrErrorMsg(val) {
      if (val != "") {
        if (this.timer1 != null) {
          window.clearTimeout(this.timer1);
        }
        if (this.timer2 != null) {
          window.clearTimeout(this.timer2);
        }
        this.fadeOut = false;
        this.showErrorMsg = true;
        this.timer1 = setTimeout(() => {
          this.fadeOut = true;
          if (this.timer1 != null) {
            clearTimeout(this.timer1);
          }
          this.timer2 = setTimeout(() => {
            if (this.timer2 != null) {
              clearTimeout(this.timer2);
            }
            this.fadeOut = false;
            this.showErrorMsg = false;
            this.$store.dispatch("setQrErrorMsg", "");
          }, 900);
        }, this.time);
      }
    }
  },
  mounted() {
    let el = this.$refs.handLock,
      container = this.$refs.handBox;
    new handLock({
      container: container,
      el: el,
      n: 3
    }).init();
  },
  created() {
    //this.$message();
  },
  methods: {
    forgetPwd() {
      qrTool.scan(2);
    },
    handleScan() {
      qrTool.scan(1);
    }
  }
};
</script>
<style lang="scss" scoped>
.scan-ui {
  z-index: 10;
  font-size: 0.11rem;
  background-image: url(~@/assets/img/app/UI_shouji_BG_00.jpg);
  background-size: cover;
  .toast-box {
    z-index: 1;
    color: #fff;
    font-size: 0.13rem;
    line-height: 0.13rem;
    background-color: rgba(0, 0, 0, 0.7);
    padding: 0.1rem 0.2rem;
    border-radius: 0.025rem;
    bottom: 10%;
  }
  .l-box {
    width: 50%;
    height: 100%;
    float: left;
    position: relative;
    .app-version {
      position: absolute;
      bottom: 0.05rem;
      font-size: 0.1rem;
      left: 0.2rem;
    }
    .chip-png {
      width: 2.81rem;
      height: 1.08rem;
      margin-top: -0.3rem;
    }
    .logo-png {
      width: 1.64rem;
      height: 0.315rem;
      margin-top: 0.4rem;
    }
    .user-nick {
      font-size: 0.125rem;
      margin-top: 0.8rem;
      text-align: center;
      height: 0.22rem;
      color: #fdd800;
      width: 1.64rem;
      display: block;
      float: left;
      line-height: 0.22rem;
      background-image: url(~@/assets/img/app/UI_shouji_yhmBG_01.png);
      background-size: cover;
      .s-nick {
        width: 0.65rem;
        float: left;
        text-align: center;
      }
      .s2 {
        color: white;
        float: left;
        width: 0.95rem;
        height: 0.22rem;
        overflow: hidden;
        /*超出的部分隐藏起来。*/
        white-space: nowrap;
        /*不显示的地方用省略号...代替*/
        text-overflow: ellipsis;
        /* 支持 IE */
      }
    }
  }
  .r-box {
    float: left;
    width: 50%;
    height: 100%;
    position: relative;

    .r-box-content {
      .scan-btn {
        width: 2.45rem;
        height: 0.355rem;
        line-height: 0.355rem;
        margin-top: 0.11rem;
        background: url(~@/assets/img/app/UI_shouji_button_03.png);
        display: block;
        font-size: 0.15rem;
        text-align: center;
        color: #ffffff;
        background-size: cover;
      }
      .r-box-bg {
        height: 2.3rem;
        background: url(~@/assets/img/app/UI_shouji_BG_03.png);
        display: block;
        background-size: cover;
        padding: 0.2rem;
        position: relative;

        .s-yellow {
          font-size: 0.125rem;
          color: #fdd800;
          text-align: center;
          width: 3rem;
          margin-bottom: 0.11rem;
          display: block;
        }

        .scan-tips {
          padding: 0.04rem;
          .tips {
            height: 0.85rem;
            color: white;
            display: block;
            position: relative;
            .tips-bg {
              width: 2.375rem;
              height: 0.85rem;
            }
            .tips-content {
              width: 2.24rem;
              height: 0.8rem;
              text-indent: 0.2rem;
              font-size: 0.14rem;
              line-height: 0.26rem;
              display: inline-block;
            }
          }
          .scan-demo {
            width: 2.24rem;
            height: 1.37rem;
            margin-top: 0.125rem;
          }
        }
      }
    }
    .r-handlock-content {
      .handlock-box {
        width: 3rem;
        height: 2.3rem;
        background: url(~@/assets/img/app/UI_shouji_BG_03.png);
        display: block;
        background-size: cover;
        padding: 0.2rem;
        position: relative;
      }
      #handlock {
        height: auto;
        margin: 0 auto;
      }

      #handlock canvas {
        margin: 0 auto;
      }
      .s-yellow {
        font-size: 0.125rem;
        color: #fdd800;
        text-align: center;
        width: 3rem;
        margin-bottom: 0.11rem;
        display: block;
      }
      .forget-pwd {
        width: 0.645rem;
        height: 0.16rem;
        margin: 0 auto;
        margin-top: 0.11rem;
        background: url(~@/assets/img/app/UI_shouji_WJMM_01.png);
        display: block;
        background-size: cover;
        position: relative;
        z-index: 20;
      }
    }
  }
}
</style>